import { TableBody as MuiTableBody, tableCellClasses } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
import { styled } from '../muiReexports';
export const TableBodyStyled = styled(MuiTableBody, shouldNotForwardProps('dense', 'relative'))(({ dense, relative }) => ({
    ...(dense && {
        [`.${tableCellClasses.root}`]: {
            paddingTop: 0,
            paddingBottom: 0,
        },
    }),
    ...(relative && {
        position: 'relative',
    }),
}));
